import CardFilters from 'components/filters'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { selectCardMap } from 'app-redux/deck/selectors'
import { SET_HIGHLIGHT_CARDS } from 'app-redux/active/actions/types'

type Props = {
  primaryFilter?: boolean // Prop drills down & is the component that fetches to scryfall when filtering
}

const DeckFilter = ({ primaryFilter }: Props) => {
  const cardMap = useAppSelector(selectCardMap)

  const filteredCards = useAppSelector(state => state.active.filteredCards)

  const [setHighlightCards] = useActionless(SET_HIGHLIGHT_CARDS)

  return (
    <CardFilters
      deck
      primaryFilter={primaryFilter}
      cardsToFilter={Object.values(cardMap)}
      filteredCards={filteredCards}
      setFilteredCards={setHighlightCards}
    />
  )
}

export default DeckFilter
